import React from 'react';
import { FilePond, registerPlugin } from 'react-filepond';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';

import 'filepond/dist/filepond.min.css';
import './style.scss'

registerPlugin(FilePondPluginFileValidateType, FilePondPluginFileValidateSize);

function ImageUpload(props) {
  return (
    <FilePond
      onupdatefiles={(fileItems) => { props.callFile(fileItems) }}
      allowMultiple={true}
      maxFiles={1}
      server="/api"
      acceptedFileTypes={props.filesAccepted}
      labelFileTypeNotAllowed={props.lng("documents_upload_file_invalid_file_format")}
      // labelTapToUndo=''
      labelFileProcessingComplete={props.lng("documents_upload_complete")}
      maxFileSize={props.maxSizeFile}
      labelIdle={props.lng("documents_upload_file_placeholder")}
      fileValidateTypeLabelExpectedTypes={props.lng('documents_upload_file_only_xls')}
      labelMaxFileSizeExceeded={props.lng('documents_upload_file_is_too_large')}
      labelMaxFileSize={props.lng('documents_upload_file_maximun_file_size')}
      labelFileProcessing={props.lng('documents_uploading')}
      labelTapToCancel={props.lng('documents_upload_tap_to_cancel')}
    />
  );
}

export default ImageUpload;
